import React from "react";
import { Box } from "@mui/material";
import Row from "../../../components/Row";
import ButtonLoading from "../../../components/ButtonLoading";
import { colors } from "../../../utils/constants";
import ArowIcon from "@mui/icons-material/ArrowRightAlt";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import GroupIcon from "@mui/icons-material/Group";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { landingTokens } from "../theme";
import { openWhatsAppContact } from "../constants";

interface NumbersProps {
  isMobile: boolean;
}

const numbers = [
  { icon: <FactCheckIcon />, value: "+3.100", label: "checkins realizados" },
  { icon: <WorkspacePremiumIcon />, value: "+700", label: "certificados emitidos" },
  { icon: <GroupIcon />, value: "+1.200", label: "usuários cadastrados" },
];

function Numbers({ isMobile }: NumbersProps) {
  const styles = {
    mainContainer: {
      padding: isMobile ? 4 : 16,
    },
    headingStyle: {
      fontSize: isMobile ? 22 : 32,
      fontWeight: 600,
      color: colors.primary,
      textAlign: "left" as const,
      display: "flex",
      alignItems: "center",
      gap: "12px",
    },
    subheadingStyle: {
      fontSize: 16,
      marginTop: 40,
      width: isMobile ? "100%" : "70%",
      color: "#5B6472",
    },
    navButton: {
      padding: isMobile ? 4 : 12,
      height: isMobile ? 38 : "auto",
      fontSize: isMobile ? 12 : 16,
    },
    buttonIcon: {
      marginLeft: isMobile ? 2 : 16,
      width: isMobile ? 16 : "auto",
    },
    cardNumbersContainer: {
      flexDirection: "column" as const,
      display: "flex",
      width: isMobile ? "100%" : "50%",
      gap: 3,
    },
    headerNumbers: {
      flexDirection: "column" as const,
      display: "flex",
      width: isMobile ? "100%" : "50%",
      marginBottom: isMobile ? 4 : 0,
    },
    cardStyleNumber: {
      padding: isMobile ? "20px 24px" : "28px 32px",
      backgroundColor: "#DEEEFF",
      width: "90%",
      borderRadius: `${landingTokens.radius.card}px`,
      boxShadow: landingTokens.shadow,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: "12px",
      transition: landingTokens.transition,
      "&:hover": {
        transform: "translateY(-3px)",
        boxShadow: "0 16px 34px -12px rgba(20,33,61,.28)",
      },
    },
    numberValue: {
      fontSize: isMobile ? 30 : 42,
      fontWeight: 800,
      color: colors.primary,
      lineHeight: 1,
      letterSpacing: "-0.02em",
    },
    numberLabel: {
      fontSize: isMobile ? 13 : 14,
      fontWeight: 600,
      color: "#5B6472",
      marginTop: "6px",
    },
    numberIcon: {
      width: isMobile ? 40 : 48,
      height: isMobile ? 40 : 48,
      borderRadius: "50%",
      backgroundColor: colors.white,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: colors.primary,
      flexShrink: 0,
    },
  };

  return (
    <Box sx={styles.mainContainer}>
      <Row style={{ width: "100%", flexDirection: isMobile ? "column" : "row" }}>
        <Box sx={styles.headerNumbers}>
          <Box component="span" sx={styles.headingStyle}>
            <CheckCircleIcon sx={{ color: colors.primary }} /> Números
          </Box>
          <span style={styles.subheadingStyle}>
            Nossos números estão crescendo cada vez mais e validando essa poderosa ferramenta que
            já fez a diferença em muitos eventos online e presencial por todo o Brasil.
          </span>

          <ButtonLoading
            label="Quero fazer um evento"
            className="landing-hover-lift"
            style={{
              ...styles.navButton,
              color: colors.white,
              backgroundColor: colors.status.green,
              marginTop: 32,
              width: "65%",
            }}
            endIcon={<ArowIcon style={styles.buttonIcon} />}
            onClick={openWhatsAppContact}
          />
        </Box>

        <Box sx={styles.cardNumbersContainer}>
          {numbers.map((item) => (
            <Box key={item.label} sx={styles.cardStyleNumber}>
              <Box>
                <Box component="div" sx={styles.numberValue}>
                  {item.value}
                </Box>
                <Box component="div" sx={styles.numberLabel}>
                  {item.label}
                </Box>
              </Box>
              <Box sx={styles.numberIcon}>{item.icon}</Box>
            </Box>
          ))}
        </Box>
      </Row>
    </Box>
  );
}

export default Numbers;
